import { baseResolver } from "resolvers";

const baseModel = (data) => baseResolver(data);

export default baseModel;
